import React from 'react';
import { BiError } from 'react-icons/bi';

const ErrorMessage = ({ message, onRetry }) => {
  return (
    <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-white tw-bg-opacity-90 tw-z-50">
      <div className="tw-bg-white tw-rounded-lg tw-shadow-xl tw-p-6 tw-max-w-md tw-text-center">
        <BiError className="tw-text-red-500 tw-text-5xl tw-mx-auto tw-mb-4" />
        <h3 className="tw-text-xl tw-font-semibold tw-text-gray-800 tw-mb-2">
          Error Loading Data
        </h3>
        <p className="tw-text-gray-600 tw-mb-6">{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="tw-px-4 tw-py-2 tw-bg-blue-600 tw-text-white tw-rounded-md hover:tw-bg-blue-700 tw-transition-colors"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;